/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Usage_BillableInputs */



/**
* | output |
* | --- |
* | "Billable AI usage" |
*
* @param {Partner_Dashboard_Detail_Usage_BillableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_usage_billable = /** @type {((inputs?: Partner_Dashboard_Detail_Usage_BillableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Usage_BillableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechenbare KI-Nutzung")
	return /** @type {LocalizedString} */ ("Billable AI usage")
});